import { useCallback, useMemo } from 'react';

import { useLocalStorageValueAsync } from '#src/app/shared/hooks/storage';
import { parsePendingSignature } from '#src/app/shared/utils/signature';
import type { PendingSignature } from '#src/app/shared/utils/signature';

export type { PendingSignature } from '#src/app/shared/utils/signature';

export function usePendingSignature(
	petitionId: string,
): [PendingSignature | undefined, (signature: PendingSignature) => void] {
	const [pendingSignatureString, setPendingSignatureString] = useLocalStorageValueAsync(
		`pending-signature-${petitionId}`,
	);

	const parsed = useMemo(() => parsePendingSignature(pendingSignatureString), [pendingSignatureString]);
	const set = useCallback(
		(signature: PendingSignature) => {
			setPendingSignatureString(JSON.stringify(signature));
		},
		[setPendingSignatureString],
	);

	return [parsed, set];
}
